export const Permissions = {
  ADMINISTRATION: {
    USERS: {
      VIEW_ALL: [
        'get-all-roles',
        'get-all-permissions',
        'get-specific-role',
        'get-specific-permission',
        'assign-permissions-to-user',
        'assign-roles-to-user',
        'delete-specific-user',
        'get-specific-user',
        'get-all-users',
        'update-specific-user',
      ],
      USERS_LIST: {
        VIEW_PAGE: 'get-all-users',
        DELETE_USER: 'delete-specific-user',
        CREATE_USER: 'create-user',
      },
      USER_DETAILS: {
        VIEW: 'get-specific-user',
        UPLOAD_AVATAR: 'upload-specific-user-avatar',
        UPDATE_USER_STATUS: 'update-specific-user-status',
        UPDATE_USER: 'update-specific-user',
        EDIT_OWN_ROLE: 'update-self-role',
        GET_USER_PERMISSIONS: 'get-specific-user',
        UPDATE_USER_PERMISSIONS: 'assign-permissions-to-user',
        GET_USER_ROLES: 'get-specific-user',
        UPDATE_USER_ROLES: 'assign-roles-to-user',
      },
    },
    PERMISSIONS: {
      VIEW_ALL: [
        'get-all-permissions',
        'get-specific-permission',
      ],
      VIEW_LIST: 'get-all-permissions',
      VIEW_DETAILS: 'get-specific-permission',
    },
    ROLES: {
      VIEW_ALL: [
        'get-all-roles',
        'delete-specific-role',
        'create-role',
        'get-specific-role',
        'get-specific-role-permissions',
        'update-specific-role',
        'update-specific-role-permissions',
      ],
      ROLES_LIST: {
        VIEW_PAGE: 'get-all-roles',
        DELETE_ROLE: 'delete-specific-role',
        CREATE_ROLE: 'create-role',
      },
      ROLE_DETAILS: {
        VIEW: 'get-specific-role',
        EDIT_ROLE_DETAILS: 'update-specific-role',
        EDIT_PERMISSIONS: 'attach-permissions-to-role',
        GET_ROLE_PERMISSIONS: 'get-specific-role-permissions',
      },
    },
    LOGS: {
      LIST: 'get-all-logs',
      DETAILS: 'get-specific-log',
      VIEW_MODEL: 'get-specific-log-model',
    },
  },

  TRANSLATIONS: {
    LANGUAGES: {
      LANGUAGES_LIST: {
        VIEW_PAGE: 'get-all-languages',
        CREATE: 'create-language',
        EDIT: 'update-specific-language',
        DELETE: 'delete-specific-language',
      },
    },
    STRUCTURES: {
      LIST: {
        VIEW_PAGE: 'get-all-structures',
        EDIT: 'create-structure',
      },
      DETAILS: {
        GET: 'get-specific-structure',
        EDIT: 'create-structure',
      },
    },
    DICTIONARIES: {
      LIST: {
        VIEW_PAGE: 'get-all-dictionaries',
        CREATE: 'create-dictionary',
        DELETE: 'delete-dictionary',
      },
      DETAILS: {
        VIEW: 'get-specific-dictionary',
        EDIT: 'update-specific-dictionary',
      },
      FILES: {
        IMPORT: 'import-dictionaries',
        EXPORT: 'export-specific-dictionary',
        EXPORT_TEMPLATE: 'export-specific-dictionary-template',
      },
    },
  },

  CONTENT: {
    IMAGES: {
      LIST: 'get-all-images',
      FIND: 'get-specific-image',
      VIEW_BEEPANEL: 'view-image-beepanel',
      CLONE: 'clone-specific-image',
      REOPEN: 'reopen-specific-image',
      DOWNLOAD: 'download-specific-image',
      TAGS: {
        LIST: 'get-specific-image-tags-data',
        UPDATE: 'update-specific-image-tags',
        VIEW_RECOMMENDED_IMAGES: 'get-specific-image-recommendations',
      },
      RESERVE_STATISTICS: {
        LIST: 'get-all-reserve-statistics',
        EDIT_TABLE_STRUCTURE: 'update-reserve-statistics-structure',
        EDIT_REFERENCES: 'update-reserve-statistics-benchmarks',
      },
      SEARCH_SIMILAR: 'search-similar-images',
    },
    CATEGORIES: {
      LIST: 'get-all-categories',
      VIEW: 'get-specific-category',
      CREATE: 'create-category',
      EDIT: 'update-specific-category',
      DELETE: 'delete-specific-category',
      UNPUBLISH: 'unpublish-specific-category',
      EDIT_OPTIONS: 'update-specific-category-options',
      PRIORITIES: {
        LIST: 'get-categories-priorities',
        EDIT: 'update-categories-priorities',
      },
    },
    ACHIEVEMENTS: {
      LIST: 'get-all-achievements',
      VIEW: 'get-specific-achievement',
      CREATE: 'create-achievement',
      EDIT: 'update-specific-achievement',
      DELETE: 'delete-specific-achievement',
    },
    BONUSES: {
      LIST: 'get-all-bonuses',
      VIEW: 'get-specific-bonus',
      CREATE: 'create-bonus',
      EDIT: 'update-specific-bonus',
      UNPUBLISH: 'unpublish-specific-bonus',
      DELETE: 'delete-specific-bonus',
    },
    NEWS: {
      LIST: 'get-all-news',
      FIND: 'get-specific-news',
      CREATE: 'create-news',
      EDIT: 'update-specific-news',
      DELETE: 'delete-specific-news',
      PRIORITY: 'update-priority-news',
    },
    COLLECTIONS: {
      LIST: 'get-all-collections',
      VIEW: 'get-specific-collection',
      CREATE: 'create-collection',
      EDIT: 'update-specific-collection',
      UNPUBLISH: 'update-specific-collection',
      DELETE: 'delete-specific-collection',
      PRIORITIES: {
        LIST: 'get-collections-priorities',
        EDIT: 'update-collections-priorities',
      },
    },
    FEEDS: {
      PLANNING: {
        STORAGE: 'get-all-feeds-planning',
        BOARD: {
          LIST: 'get-all-feeds-planning-board',
          DETAILS: 'get-specific-feed-planning-board',
          PUBLISH: 'publish-specific-feed-planning-board',
          UNPUBLISH: 'unpublish-specific-feed-planning-board',
        },
      },
      LIST: 'get-all-feeds-list',
      RELEASED: 'get-all-feeds-released',
      ARCHIVED: 'get-all-feeds-archived',
      TRASHED: 'get-all-feeds-trashed',
      IMAGE: {
        UPDATE: 'update-specific-image',
        SET_DELETE: 'update-specific-image-status-deleted',
        SET_ARCHIVED: 'update-specific-image-status-archive',
        SET_TRASHED: 'update-specific-image-status-trash',
        SET_DRAFT: 'update-specific-image-status-draft',
      },
    },
  },

  FEATURED: {
    FEATURES: {
      DAILY: {
        LIST: 'get-all-featured-daily',
        FIND: 'get-specific-featured-daily',
        CREATE: 'create-featured-daily',
        EDIT: 'update-specific-featured-daily',
        DELETE: 'delete-specific-featured-daily',
      },
      EDITOR_CHOICE: {
        LIST: 'get-all-featured-editors-choice',
        FIND: 'get-specific-featured-editors-choice',
        CREATE: 'create-featured-editors-choice',
        EDIT: 'update-specific-featured-editors-choice',
        DELETE: 'delete-specific-featured-editors-choice',
      },
      EXTERNAL_PROMO: {
        LIST: 'get-all-featured-external-promo',
        FIND: 'get-specific-featured-external-promo',
        CREATE: 'create-featured-external-promo',
        EDIT: 'update-specific-featured-external-promo',
        DELETE: 'delete-specific-featured-external-promo',
      },
      PRIORITY: {
        LIST: 'get-featured-content-priorities',
        UPDATE: 'update-featured-content-priorities',
      },
    },
  },

  TEMPLATE_CONSTRUCTORS: {
    TEMPLATES: {
      LIST: 'get-all-templates',
      FIND: 'get-specific-template',
      CREATE: 'create-template',
      EDIT: 'update-specific-template',
      DELETE: 'delete-specific-template',
      FILTER: 'filter-all-templates',
      GET_CONTENT_TYPES: 'get-all-template-content-types',
      CLONE: 'clone-specific-template',
      VISUALIZATIONS: {
        LIST: 'get-all-template-visualizations',
        CREATE: 'create-template-visualization',
        VIEW: 'get-specific-template-visualization',
        EDIT: 'update-specific-template-visualization',
        DELETE: 'delete-specific-template-visualization',
        TEMPLATE_VISUALIZATIONS_KEYS: 'get-specific-template-data-visualizations-config',
        VIEW_NEWS_VISUALIZATIONS: 'show-news-visualization',
        VIEW_PUSH_NOTIFICATION_VISUALIZATIONS: 'show-push-notification-visualization',
      },
    },
    PRESETS: {
      LIST: 'get-all-presets',
      FIND: 'get-specific-preset',
      CREATE: 'create-preset',
      EDIT: 'update-specific-preset',
      DELETE: 'delete-specific-preset',
    },
  },

  FILTER_CONSTRUCTORS: {
    FILTERS: {
      LIST: 'get-all-filters',
      FIND: 'get-specific-filter',
      CREATE: 'create-filter',
      EDIT: 'update-specific-filter',
      DELETE: 'delete-specific-filter',
      OPTIONS: 'get-all-filter-options',
    },
    GROUPS: {
      LIST: 'get-all-filter-groups',
      FIND: 'get-specific-filter-group',
      CREATE: 'create-filter-group',
      EDIT: 'update-specific-filter-group',
      DELETE: 'delete-specific-filter-group',
      CLONE: 'clone-specific-filter-group',
    },
    COLLECTIONS: {
      LIST: 'get-all-filter-collections',
      FIND: 'get-specific-filter-collection',
      CREATE: 'create-filter-collection',
      EDIT: 'update-specific-filter-collection',
      DELETE: 'delete-specific-filter-collection',
      CLONE: 'clone-specific-filter-collection',
      PUBLISH: 'publish-specific-filter-collection',
      UNPUBLISH: 'unpublish-specific-filter-collection',
    },
  },

  OTHER: {
    PUSH_ICONS: {
      LIST: {
        VIEW: 'get-all-push-icons',
        CREATE: 'create-push-icon',
        EDIT: 'update-specific-push-icon',
        DELETE: 'delete-specific-push-icon',
      },
    },
    DEEPLINKS: {
      LIST: 'get-all-deeplinks',
      CREATE: 'create-deeplink',
    },
    STATIC_CONTENT_RESET: {
      LIST: 'get-all-static-content-reset-logs',
      RESET: 'reset-static-content',
    },
    POPUPS: {
      LIST: 'get-all-popups',
      FIND: 'get-specific-popup',
      CREATE: 'create-popup',
      EDIT: 'update-specific-popup',
      DELETE: 'delete-specific-popup',
      UNPUBLISH: 'update-specific-popup',
      PRIORITY: {
        LIST: 'get-popups-priorities',
        UPDATE: 'update-popups-priorities',
      },
    },
    NOTIFICATIONS: {
      LOCAL: {
        LIST: 'get-all-local-notifications',
        FIND: 'get-specific-local-notification',
        CREATE: 'create-local-notification',
        EDIT: 'update-specific-local-notification',
        DELETE: 'delete-specific-local-notification',
        UNPUBLISH: 'unpublish-specific-local-notification',
      },
      PUSH: {
        LIST: 'get-all-push-notifications',
        FIND: 'get-specific-push-notification',
        CREATE: 'create-push-notification',
        EDIT: 'update-specific-push-notification',
        DELETE: 'delete-specific-push-notification',
        CLONE: 'clone-specific-push-notification',
        TEST: 'send-test-push-notification',
        SCHEDULE: {
          LIST: 'get-all-push-notifications-schedule',
          FIND: 'get-specific-push-notification-schedule',
          CREATE: 'create-push-notification-schedule',
          EDIT: 'update-specific-push-notification-schedule',
          DELETE: 'delete-specific-push-notification-schedule',
          UNPUBLISH: 'unpublish-specific-push-notification-schedule',
        },
      },
    },
    EVENTS: {
      LIST: 'get-all-events',
      FIND: 'get-specific-event',
      CREATE: 'create-event',
      EDIT: 'update-specific-event',
      DELETE: 'delete-specific-event',
      UNPUBLISH: 'unpublish-specific-event',
    },
    STICKERS: {
      LIST: 'get-all-stickers',
      FIND: 'get-specific-sticker',
      CREATE: 'create-sticker',
      EDIT: 'update-specific-sticker',
      DELETE: 'delete-specific-sticker',
      UNPUBLISH: 'unpublish-specific-sticker',
    },
  },
};

